import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  Subscription,
  switchMap,
  tap,
} from 'rxjs';
import { ScreenType } from 'src/app/enums/ScreenType';
import { UserRegDetails } from 'src/app/models/user';
import { Visitor } from 'src/app/models/visitor';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import { environment } from 'src/app/environments/environments';
import { EncryptionService } from 'src/app/services/Encryption/encryption.service';

@Component({
  selector: 'app-rapid-schedule-visitor',
  templateUrl: './rapid-schedule-visitor.component.html',
  styleUrls: ['./rapid-schedule-visitor.component.scss'],
})
export class RapidScheduleVisitorComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: UserRegDetails[],
    private formbuilder: FormBuilder,
    private _screenSize: AumyeResponsiveScreenService,
    private httpclient: HttpClient,
    private encryptionService: EncryptionService,
    private dialogRefTem: MatDialogRef<RapidScheduleVisitorComponent>
  ) {
    this._screenSize.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
  }
  phoneNumber = '';
  selectedOption: string;
  minDate = new Date();
  maxDate: any;
  screenSize: ScreenType;
  ScreenType = ScreenType;
  statusOptions: string[] = ['Open', 'Close', 'Verified'];
  isChecked = false;
  isEnabled = false;
  rapidScheduleVisitor = this.formbuilder.group({
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    phoneNumber: ['', [Validators.required]],
    visitDateTime: [, Validators.required],
    ePassValidity: new FormControl({ value: '', disabled: true }),
    sendQR: [false],
    reVisitor: [],
    isReVisit: [false],
  });
  printerAllowed = environment.printerAllowed;
  phoneForm = new FormGroup({
    phone: new FormControl(undefined, [Validators.required]),
  });
  isEnable = false;
  isUniqueVisitor = true;
  isValid = true;
  visitors: Visitor[] = [];
  baseServerURL = environment.apiUrl;
  private phoneInputSubscription: Subscription | null = null;
  previousPhoneNumber: string | null = null;
  OrgId: string = null;
  minPassValidityDate: Date | null = null;
  ngOnInit(): void {
    this.OrgId = this.encryptionService.getCurrentUser().organizationID;
    this.rapidScheduleVisitor
      .get('visitDateTime')
      ?.valueChanges.subscribe((visitDate: Date) => {
        if (visitDate) {
          const minDate = new Date(visitDate);
          minDate.setDate(minDate.getDate() + 1); // Add 1 day
          this.minPassValidityDate = minDate;
        } else {
          this.minPassValidityDate = null;
        }
      });
    if (this.phoneInputSubscription) {
      this.phoneInputSubscription.unsubscribe();
    }
    // Listen for phone number input changes
    this.phoneInputSubscription = this.phoneForm
      .get('phone')
      ?.valueChanges.pipe(
        debounceTime(500), // Wait 500ms for user input to stabilize
        distinctUntilChanged(), // Prevent duplicate calls for the same input
        filter(() => this.phoneForm.get('phone')?.valid), // Only valid inputs proceed
        tap(() => {
          if (!this.phoneForm.get('phone')?.valid) {
            this.resetFields();
          }
        }), // Reset fields before making API call
        tap((phoneNumber) => {
          this.checkPhoneNumber(phoneNumber);
        }) // Call the void function
      )
      .subscribe();

    this.phoneForm.get('phone')?.valueChanges.subscribe((value) => {
      if (!this.phoneForm.get('phone')?.valid) {
        this.rapidScheduleVisitor.disable();
      }
    });
    this.rapidScheduleVisitor.disable();
  }
  inputValidator(event: { charCode: number }) {
    return (
      (event.charCode != 8 && event.charCode == 0) ||
      (event.charCode >= 48 && event.charCode <= 57)
    );
  }
  onChangeNumber(val: any) {
    this.rapidScheduleVisitor.controls.phoneNumber.setValue(
      this.phoneForm.value.phone
    );
  }
  onCheckboxChange() {
    if (this.isChecked) {
      this.rapidScheduleVisitor.controls.sendQR.setValue(false);
      this.isChecked = false;
    } else {
      this.rapidScheduleVisitor.controls.sendQR.setValue(true);
      this.isChecked = true;
    }
  }
  resetFields(): void {
    this.rapidScheduleVisitor.reset();
    // this.visitors = [];
    // this.isUniqueVisitor = false;
    // this.isValid = false;
    this.rapidScheduleVisitor.disable();
    this.rapidScheduleVisitor.controls.ePassValidity.disable();
  }
  searchedImage: string = null;
  checkPhoneNumber(phoneNumber: string): void {
    let baseServerURL = this.baseServerURL + 'CheckExistingVisitor';
    let auth_token = localStorage.getItem('AccessToken');
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: auth_token,
      }),
    };
    this.httpclient
      .get(
        `${baseServerURL}?Number=${phoneNumber}&OrgId=${this.OrgId}&Type=2`,
        httpOptions
      )
      .subscribe(
        (response: any) => {
          this.rapidScheduleVisitor.reset();
          if (response.exists) {
            if (response.isValid) {
              this.isUniqueVisitor = false;
              this.isValid = response.isValid;
              this.visitors = response.visitor;
              this.setInputField();
            } else {
              this.visitors = [];
              this.visitors = response.visitor;
              this.isUniqueVisitor = false;
              this.isValid = false;
            }
          } else {
            this.isEnable = true;
            this.rapidScheduleVisitor.enable();
            this.rapidScheduleVisitor.controls.ePassValidity.disable();
            this.isUniqueVisitor = true;
            this.visitors = [];
            this.rapidScheduleVisitor.controls.isReVisit.setValue(false);
            this.rapidScheduleVisitor.controls.sendQR.setValue(false);
            this.rapidScheduleVisitor.controls.phoneNumber.setValue(
              this.phoneForm.value.phone
            );
          }
          this.previousPhoneNumber = phoneNumber;
        },
        (error) => {
          console.error('Error checking phone number', error);
        }
      );
  }
  setInputField() {
    this.rapidScheduleVisitor.controls.firstName.setValue(
      this.visitors[0].firstName
    );
    this.rapidScheduleVisitor.controls.visitDateTime.enable();
    this.rapidScheduleVisitor.controls.lastName.setValue(
      this.visitors[0].lastName
    );
    this.rapidScheduleVisitor.controls.phoneNumber.setValue(
      this.visitors[0].phoneNumber
    );
    this.searchedImage = this.visitors[0].profilePicture;
    this.rapidScheduleVisitor.controls.reVisitor.setValue(this.visitors);
    this.rapidScheduleVisitor.controls.isReVisit.setValue(true);
    this.rapidScheduleVisitor.controls.sendQR.setValue(false);
    this.isEnable = true;
  }
  onSubmit() {
    // Enable all fields before getting the raw value
    Object.keys(this.rapidScheduleVisitor.controls).forEach((key) => {
      this.rapidScheduleVisitor.get(key)?.enable();
    });

    // Close the dialog manually with full form value
    this.dialogRefTem.close(this.rapidScheduleVisitor.getRawValue());
  }

  isManuallyCheck = false;
  onManualCheckVisitor() {
    let val: any = this.visitors[0];
    val['isManualCheckout'] = true;
    let baseServerURL = this.baseServerURL + 'UpdateVisitor';
    let auth_token = localStorage.getItem('AccessToken');
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: auth_token,
      }),
    };
    this.httpclient
      .post(`${baseServerURL}`, val, {
        headers: httpOptions.headers,
        responseType: 'text',
      })
      .subscribe(
        (response: any) => {
          this.setInputField();
          this.isValid = true;
          this.isManuallyCheck = true;
          this.rapidScheduleVisitor.enable();
          this.rapidScheduleVisitor.controls.ePassValidity.disable();
          this.rapidScheduleVisitor.controls.phoneNumber.setValue(
            this.phoneForm.value.phone
          );
        },
        (error) => {
          console.error('Error checking phone number', error);
        }
      );
  }
  onEditDetails() {
    this.rapidScheduleVisitor.enable();
    this.rapidScheduleVisitor.controls.ePassValidity.disable();
  }
  ngOnDestroy(): void {
    if (this.phoneInputSubscription) {
      this.phoneInputSubscription.unsubscribe();
    }
  }
}
